/**
 * Открыть собранный печатный документ в новом окне; если окно заблокировано
 * — скачать его HTML-файлом. Один путь для отчёта по записи и для выгрузки
 * «Голоса клиента» (#848).
 */
export function openPrintDocument(html: string, fallbackFilename: string): void {
  const printWindow = window.open('', '_blank');
  if (!printWindow) {
    const blob = new Blob([html], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fallbackFilename;
    a.click();
    URL.revokeObjectURL(url);
    return;
  }
  printWindow.document.write(html);
  printWindow.document.close();
}
